import { createStorage, readValue, StorageProperties } from './create-storage';

/**
 * Custom hook for managing local storage
 * @author Karim Bakkali
 * @example
 * // The hook will read value from localStorage.getItem('atarim-color-scheme')
 * // If localStorage is not available or value at a given key does not exist
 * // 'dark' will be assigned to value variable
 * const [value, setValue, removeValue] = useLocalStorage({
 *   key: 'atarim-color-scheme',
 *   defaultValue: 'dark',
 * });
 *
 * // Set a new value
 * setValue('light');
 *
 * // Update value based on current state
 * setValue((current) => (current === 'dark' ? 'light' : 'dark'));
 *
 * // Use removeValue callback to clean localStorage/sessionStorage.
 * // When value is removed it is reset to defaultValue: 'dark'
 * removeValue();
 */
export function useLocalStorage<T = string>(props: StorageProperties<T>) {
  return createStorage<T>('localStorage', 'use-local-storage')(props);
}

export const readLocalStorageValue = readValue('localStorage');
